import styled from '@emotion/styled'
import { Layout, Button, Typography, TextStylePreset } from '@vivaldis/antd-ui'
import { ArrowLeft } from '@vivaldis/icons'
import { useScreenTitle, ZIndex } from '@vivaldis/web-ui'
import { useMatch } from 'react-router-dom'
import { animated, PickAnimated, SpringValues } from 'react-spring'
import { CompanySelect } from './components/CompanySelect'
import { MenuWithAvatar } from './components/MenuWithAvatar'
import { AppBrandSwitch } from './components/AppBrandSwitch'

interface Props {
  animatedStyles: SpringValues<PickAnimated<{ width: number }>>
}

export const Header = ({ animatedStyles }: Props) => {
  const isSettingScreens = useMatch('/settings/*')
  const isViewStartUpDocumentsScreens = useMatch(
    '/start-up-documents/view-start-up-document/*'
  )

  const { title, titleAccessory } = useScreenTitle()

  return (
    <AnimatedHeader
      style={{
        paddingRight: animatedStyles.width,
        zIndex: ZIndex.navigationBar
      }}
    >
      <TitleBase>
        {isSettingScreens ? (
          <Button
            type="default"
            shape="circle"
            size="large"
            to="/"
            style={{
              marginRight: 16
            }}
          >
            <ArrowLeft />
          </Button>
        ) : null}
        {isViewStartUpDocumentsScreens ? (
          <Button
            type="default"
            shape="circle"
            size="large"
            to="/start-up-documents"
            style={{
              marginRight: 16
            }}
          >
            <ArrowLeft />
          </Button>
        ) : null}
        <Typography.Text preset={TextStylePreset.Semibold20}>
          {title}
        </Typography.Text>
        {titleAccessory}
      </TitleBase>

      <Base>
        {process.env.NODE_ENV !== 'production' ? <AppBrandSwitch /> : null}
        <CompanySelect />
        <MenuWithAvatar />
      </Base>
    </AnimatedHeader>
  )
}

const AnimatedHeader = styled(animated(Layout.Header))`
  position: fixed;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid ${props => props.theme.colorBgLayout};
`

const Base = styled('div')`
  display: flex;
  gap: 12px;
  align-items: center;
  height: 100%;
  padding-right: 16px;
`

const TitleBase = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`
